module.exports = __webpack_public_path__ + "img/banner-14.973e0cd5.jpg";